import React from "react";
import EntityFormDialog from "../components/EntityFormDialog";

export default function ApprovalInfoEditDialog({
  approvalInfoDialog,
  onClose,
  initialData,
  onSubmit,
  fields,
}) {
  return (
    <EntityFormDialog
      open={Boolean(approvalInfoDialog)}
      onClose={onClose}
      title="Chỉnh sửa thông tin phê duyệt"
      initialData={initialData}
      submitLabel="Lưu thông tin"
      onSubmit={onSubmit}
      fields={fields}
    />
  );
}
